import { Switch, Typography, Box } from '@mui/material';

const EnableSwitchConfig = (props) => {
    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Switch defaultChecked={props.defaultChecked} onChange={props.onChange} />
            <Typography variant="h6" style={{ fontWeight: 'normal' }}>
                {props.label}
            </Typography>
        </Box>
    );
}

export default EnableSwitchConfig;